/* @ngInject */
function workflowHeaderService ($state, $location, $rootScope, $translate, UdsModalService, TasksService, ViewOptionService, ModalService, AdminService, BriefingService, TaskTagsService, TimesheetService, ToastService, ConfirmationModalService, SegmentService, GroupService) {
  const getBoardFormDialogController = () => import('../../workflow/dialogs/board-form/board-form-dialog.controller')
  const getNewTaskDialogController = () => import('../../workflow/dialogs/new-task/new-task-dialog.controller')
  const getRequestFormDialogController = () => import('../../workflow/dialogs/request-form/request-form-dialog.controller')
  const getCreateTaskDialogController = () => import('../../workflow/dialogs/create-task/create-task-dialog.controller')

  let boardInfo = null

  const service = {
    getFilters,
    getRequestsFilters,
    getMyApprovalsFilters,
    getAllTasksFilters,
    getHeaderToolbar,
    getHeaderNavigation,
    mergeQuickFilters,
    openCreateTaskDialog,
    _goToCalendarPage
  }
  return service

  function goToBriefingsPage () {
    $state.go('workflow.briefings')
  }

  function goToBoardsPage () {
    $state.go('workflow.home')
  }

  function exportTimesheetReport () {
    ConfirmationModalService.createModal({
      title: $translate.instant('timesheet.exportRegisters'),
      description: $translate.instant('timesheet.confirmExportTimesheetBoard'),
      buttonCancelText: $translate.instant('timesheet.back'),
      buttonConfirmText: $translate.instant('export'),
      onConfirm: () => {
        TimesheetService.downloadBoardReport(boardInfo.id).then((response) => {
          const fileName = `board-${boardInfo.name}-${boardInfo.id}-report.xlsx`
          TimesheetService.downloadXLSX(response, fileName)
          ToastService.showSuccessToast($translate.instant('timesheet.downloadSuccessBoard', { boardName: boardInfo.name }))
          SegmentService.track('workflow-timesheet-export', {
            board_name: boardInfo.name
          })
        }).catch((error) => {
          if (error.status === 404) {
            ToastService.showErrorToast($translate.instant('timesheet.boardEmpty'))
            return
          }

          ToastService.defaultErrorToast()
        })
      }
    })
  }

  function openBoardSettings () {
    getBoardFormDialogController().then(({ BoardFormDialogController }) => {
      const boardFormDialog = UdsModalService.createModal({
        controller: BoardFormDialogController,
        modalName: 'boardFormDialog',
        data: {
          editFormData: boardInfo
        },
        onClose: (didUpdate) => {
          if (didUpdate) {
            $rootScope.$emit('workflow.reload')
          }
        }
      })

      boardFormDialog.open()
    })
  }

  function goToInbox () {
    $state.go('workflow.home', { tab: 'requests', filter: 'WAITING_RESPONSE' })
  }

  function changeVisualization (visualization) {
    const url = $location.search()

    if (url.term) {
      ViewOptionService.setSearchView(visualization)
    } else {
      ViewOptionService.set(boardInfo.id, visualization)
    }

    $location.path(`/workflow/${visualization}`).search(url)
  }

  function openNewRequestDialog (isRequestWithUser) {
    getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          boardId: boardInfo.id,
          requestWithUser: isRequestWithUser
        }
      })
    })
  }

  function openNewTaskDialog () {
    getNewTaskDialogController().then(({ NewTaskDialogController }) => {
      ModalService.showModal({
        templateId: 'newTask.html',
        templateUrl: '/workflow/dialogs/new-task/new-task-dialog.html?$$REVISION$$',
        controller: NewTaskDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          boardId: boardInfo.id
        }
      })
    })
  }

  function openCreateTaskDialog (createMore = false) {
    getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        data: {
          boardId: boardInfo.id,
          createMore
        }
      })

      modal.open()
    })
  }

  function _goToCalendarPage () {
    $state.go('marketingCalendar', {
      originModule: 'workflow',
      selectedBoard: boardInfo
    })
  }

  function setToolbarVisualization ($translate, info, path) {
    const icons = {
      '/workflow/kanban': 'kanban',
      '/workflow/list': 'menu',
      '/workflow/calendar': 'calendar'
    }

    const index = info.rightButtons.findIndex(item => item.type === 'dropdown' && item.btnType === 'icon')

    info.rightButtons[index].icon = icons[path]

    if (path !== '/workflow/kanban') {
      info.rightButtons[index].options.push({
        icon: 'kanban',
        label: $translate.instant('kanban'),
        onClick: changeVisualization.bind(this, 'kanban')
      })
    }

    if (path !== '/workflow/list') {
      info.rightButtons[index].options.push({
        icon: 'menu',
        label: $translate.instant('list'),
        onClick: changeVisualization.bind(this, 'list')
      })
    }

    if (path !== '/workflow/calendar') {
      info.rightButtons[index].options.push({
        icon: 'calendar',
        label: $translate.instant('calendar'),
        onClick: service._goToCalendarPage
      })
    }
  }

  function getHeaderToolbar ($translate, board, actions, locale, isDesktop, showFinishedTasks = false) {
    boardInfo = board

    return Promise.all([
      TasksService.getRequestsCount(),
      $rootScope.getCompanyConfigurations()
    ]).then(([count, companyConfigurations]) => {
      const toolbarInfo = getToolbarInfo($translate, actions, { locale, count, showFinishedTasks, companyConfigurations, isDesktop })

      setToolbarVisualization($translate, toolbarInfo, $location.path())

      return toolbarInfo
    })
  }

  function getPrioritiesFilter ($translate, grouped = false) {
    return {
      name: 'priorities',
      type: 'FILTER_BUTTON_SELECT',
      grouped,
      defaultValue: [],
      props: {
        label: $translate.instant('priorityFilter'),
        multiple: true,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('LOW'),
            value: 'LOW',
            icon: 'chevron-down',
            active: false,
            disabled: false,
            color: 'feedbackColorGreenPure'
          },
          {
            label: $translate.instant('MEDIUM'),
            value: 'MEDIUM',
            icon: 'minus',
            active: false,
            disabled: false,
            color: 'feedbackColorOrangePure'
          },
          {
            label: $translate.instant('HIGH'),
            value: 'HIGH',
            icon: 'chevron-up',
            active: false,
            disabled: false,
            color: 'feedbackColorRedPure'
          },
          {
            label: $translate.instant('URGENT'),
            value: 'URGENT',
            icon: 'chevron-up-double',
            active: false,
            disabled: false,
            color: 'feedbackColorRedPure'
          }
        ]
      }
    }
  }

  function getTagsFilter ($translate, grouped = false) {
    return {
      name: 'tags',
      type: 'INPUT_MULTISELECT',
      grouped,
      defaultValue: [],
      props: {
        label: $translate.instant('tags'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        loadButtonLabel: '',
        type: 'tag',
        hasMoreOptions: false,
        udsDisabled: false,
        options: []
      },
      loadData: (name, top, skip) => TaskTagsService.getTaskTags({ top, skip, search: name })
    }
  }

  function getBriefingsFilter ($translate, grouped = false) {
    return {
      name: 'form',
      type: 'INPUT_MULTISELECT',
      grouped,
      defaultValue: [],
      props: {
        label: $translate.instant('briefings'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'text',
        hasMoreOptions: false,
        udsDisabled: false,
        options: []
      },
      loadData: (search, top, skip) => BriefingService.getCompanyBriefings('WORKFLOW', null, search, top, skip)
    }
  }

  function getAuthorsFilter ($translate, grouped = false) {
    return {
      name: 'authors',
      type: 'INPUT_MULTISELECT',
      grouped,
      defaultValue: [],
      props: {
        label: $translate.instant('workflow.requester'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'user',
        hasMoreOptions: false,
        udsDisabled: false,
        options: []
      },
      loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
    }
  }

  function getGroupsFilter ($translate, grouped = false) {
    return {
      name: 'groups',
      type: 'INPUT_MULTISELECT',
      grouped,
      defaultValue: [],
      props: {
        label: $translate.instant('groups'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'group',
        hasMoreOptions: false,
        udsDisabled: false,
        options: []
      },
      loadData: (search, top, skip) => GroupService.getGroups(top, skip, { searchTerm: search })
    }
  }

  function getCreatedAtRangeFilter ($translate, locale, grouped = false) {
    return {
      name: 'createdAtRange',
      type: 'DATE_RANGE_PICKER',
      grouped,
      defaultValue: '',
      props: {
        locale,
        label: $translate.instant('creationDate'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    }
  }

  function getDeliveryDateRangeFilter ($translate, locale, grouped = false) {
    return {
      name: 'deliveryDateRange',
      type: 'DATE_RANGE_PICKER',
      grouped,
      defaultValue: '',
      props: {
        locale,
        label: $translate.instant('deliveryDate'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    }
  }

  function getAssigneesFilter ($translate, grouped = false) {
    return {
      name: 'assignees',
      type: 'INPUT_MULTISELECT',
      grouped,
      defaultValue: [],
      props: {
        label: $translate.instant('workflow.assignee'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'user',
        hasMoreOptions: false,
        udsDisabled: false,
        options: []
      },
      loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
    }
  }

  function getFilters ($translate, locale = 'pt-br', showFinishedTasks, showActiveAsDefaultValue, showDaysInStageExceededAsDefaultValue = false, showTaskStatusDefaultValues = false, defaultDateRangeFilters = null) {
    const activeItems = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: !!showActiveAsDefaultValue,
      disabled: false
    }

    const exceededItems = {
      label: $translate.instant('exceeded'),
      value: 'exceeded',
      icon: 'clear',
      active: !!showDaysInStageExceededAsDefaultValue,
      disabled: false
    }

    const taskStatusItems = [{
      label: $translate.instant('inboxStatus'),
      value: 'INBOX',
      icon: 'arrow-down',
      active: !!showTaskStatusDefaultValues,
      disabled: false
    },
    {
      label: $translate.instant('inProgress'),
      value: 'PROGRESS',
      icon: 'arts',
      active: !!showTaskStatusDefaultValues,
      disabled: false
    },
    {
      label: $translate.instant('underReview'),
      value: 'REVIEW',
      icon: 'clock',
      active: !!showTaskStatusDefaultValues,
      disabled: false
    },
    {
      label: $translate.instant('adjustments'),
      value: 'WAITING_ADM_ADJUST',
      icon: 'alert-triangle',
      active: !!showTaskStatusDefaultValues,
      disabled: false
    }
    ]

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showActiveAsDefaultValue ? activeItems : null,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            activeItems,
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'daysInStage',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showDaysInStageExceededAsDefaultValue ? exceededItems : null,
        props: {
          label: $translate.instant('maxDaysInStage'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('inTime'),
              value: 'inTime',
              icon: 'success',
              active: false,
              disabled: false
            },
            exceededItems
          ]
        }
      },
      {
        name: 'taskTypes',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('type'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('requests'),
              value: 'REQUEST',
              icon: 'workflow',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('tasks'),
              value: 'TASK',
              icon: 'tasks',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('subtaskFilter'),
              value: 'SUBTASK',
              icon: 'subtask',
              active: false,
              disabled: false
            }
          ]
        }
      },
      getPrioritiesFilter($translate),
      {
        name: 'taskStatus',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showTaskStatusDefaultValues ? [...taskStatusItems] : [],
        props: {
          label: $translate.instant('status'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            ...taskStatusItems,
            {
              label: $translate.instant('done'),
              value: 'DONE',
              icon: 'check',
              active: showFinishedTasks,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'taskTags',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('tags'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          loadButtonLabel: '',
          type: 'tag',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (name, top, skip) => TaskTagsService.getTaskTags({ top, skip, search: name })
      },
      {
        name: 'form',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('briefings'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => BriefingService.getCompanyBriefings('WORKFLOW', null, search, top, skip)
      },
      {
        name: 'assignees',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('workflow.assignee'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'user',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
      },
      {
        name: 'authors',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('workflow.requester'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'user',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
      },
      {
        name: 'groups',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('groups'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'group',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => GroupService.getGroups(top, skip, { searchTerm: search })
      },
      {
        name: 'createdAtRange',
        type: 'DATE_RANGE_PICKER',
        grouped: true,
        defaultValue: defaultDateRangeFilters?.createdAtStart ? {
          start: defaultDateRangeFilters?.createdAtStart,
          end: defaultDateRangeFilters?.createdAtEnd
        } : '',
        props: {
          locale,
          label: $translate.instant('creationDate'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      },
      {
        name: 'deliveryDateRange',
        type: 'DATE_RANGE_PICKER',
        grouped: true,
        defaultValue: defaultDateRangeFilters?.deliveryDateStart ? {
          start: defaultDateRangeFilters?.deliveryDateStart,
          end: defaultDateRangeFilters?.deliveryDateEnd
        } : '',
        props: {
          locale,
          label: $translate.instant('deliveryDate'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      }
    ]

    $rootScope.$broadcast('advancedSearchFilter.filterApplied', filters)

    return filters
  }

  function getRequestsFilters ($translate, locale = 'pt-br') {
    const activeItems = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: false,
      disabled: false
    }

    const taskStatusItems = [{
      label: $translate.instant('waitingApproval'),
      value: 'WAITING_RESPONSE',
      icon: 'arrow-down',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('adjustments'),
      value: 'WAITING_USER_ADJUST',
      icon: 'edit',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('rejected'),
      value: 'REJECTED',
      icon: 'clear',
      active: false,
      disabled: false
    }
    ]

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: activeItems,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            activeItems,
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'taskStatus',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('status'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            ...taskStatusItems
          ]
        }
      },
      getBriefingsFilter($translate, false),
      getAuthorsFilter($translate, false),
      getGroupsFilter($translate, false),
      getCreatedAtRangeFilter($translate, locale, false)
    ]

    $rootScope.$broadcast('advancedSearchFilter.filterApplied', filters)

    return filters
  }

  function getMyApprovalsFilters ($translate, locale = 'pt-br') {
    const activeItems = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: false,
      disabled: false
    }

    const statusItems = [{
      label: $translate.instant('pending'),
      value: 'PENDING',
      icon: 'clock',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('adjustments'),
      value: 'ADJUST',
      icon: 'clock',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('approved'),
      value: 'APPROVED',
      icon: 'success',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('reproved'),
      value: 'REJECTED',
      icon: 'clear',
      active: false,
      disabled: false
    }
    ]

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: activeItems,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            activeItems,
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      getPrioritiesFilter($translate),
      {
        name: 'status',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('approvalStatus'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            ...statusItems
          ]
        }
      },
      getTagsFilter($translate, false),
      getBriefingsFilter($translate, false),
      getAssigneesFilter($translate, false),
      getAuthorsFilter($translate, false),
      getGroupsFilter($translate, false),
      getCreatedAtRangeFilter($translate, locale, true),
      getDeliveryDateRangeFilter($translate, locale, true)
    ]

    $rootScope.$broadcast('advancedSearchFilter.filterApplied', filters)

    return filters
  }

  function getAllTasksFilters ($translate, locale = 'pt-br', showActiveAsDefaultValue = true) {
    const activeItems = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: false,
      disabled: false
    }

    const stageDeadlineItems = [{
      label: $translate.instant('inTime'),
      value: 'inTime',
      icon: 'success',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('exceeded'),
      value: 'exceeded',
      icon: 'clear',
      active: false,
      disabled: false
    }]

    const typeItems = [{
      label: $translate.instant('requests'),
      value: 'REQUEST',
      icon: 'workflow',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('tasks'),
      value: 'TASK',
      icon: 'tasks',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('subtasksSection.sectionTitle'),
      value: 'SUBTASK',
      icon: 'subtask',
      active: false,
      disabled: false
    }]

    const statusItems = [{
      label: $translate.instant('inboxStatus'),
      value: 'INBOX',
      icon: 'shapes',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('inProgress'),
      value: 'PROGRESS',
      icon: 'arts',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('underReview'),
      value: 'REVIEW',
      icon: 'clock',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('adjustments'),
      value: 'WAITING_ADM_ADJUST',
      icon: 'alert-triangle',
      active: false,
      disabled: false
    },
    {
      label: $translate.instant('done'),
      value: 'DONE',
      icon: 'check',
      active: false,
      disabled: false
    }]

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showActiveAsDefaultValue ? activeItems : null,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            activeItems,
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'daysInStage',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('maxDaysInStage'),
          multiple: false,
          switchMode: false,
          udsDisabled: false,
          options: [
            ...stageDeadlineItems
          ]
        }
      },
      {
        name: 'type',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('type'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            ...typeItems
          ]
        }
      },
      getPrioritiesFilter($translate, false),
      {
        name: 'status',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('approvalStatus'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            ...statusItems
          ]
        }
      },
      getTagsFilter($translate, false),
      getBriefingsFilter($translate, false),
      getAssigneesFilter($translate, false),
      getAuthorsFilter($translate, false),
      getGroupsFilter($translate, false),
      getCreatedAtRangeFilter($translate, locale, true),
      getDeliveryDateRangeFilter($translate, locale, true)
    ]

    $rootScope.$broadcast('advancedSearchFilter.filterApplied', filters)

    return filters
  }

  function getToolbarInfo ($translate, actions, options) {
    const { locale, count, showFinishedTasks, companyConfigurations, isDesktop } = options
    const { onSearch, onFilter, onQuickFilters, value } = actions

    const filters = getFilters($translate, locale, showFinishedTasks, true)
    const enableTimesheet = Boolean(companyConfigurations?.ENABLE_TIMESHEET)

    if (isDesktop) {
      const toolbar = {
        leftButtons: [
          {
            type: 'button',
            btnType: 'tertiary',
            label: $translate.instant('createdByMe'),
            onClick: onQuickFilters.bind(this, 'createdByMe'),
            class: 'created-by-me'
          },
          {
            type: 'button',
            btnType: 'tertiary',
            label: $translate.instant('assignedToMeFilter'),
            onClick: onQuickFilters.bind(this, 'assignedToMe'),
            class: 'assigned-to-me'
          },
          {
            type: 'button',
            btnType: 'tertiary',
            label: $translate.instant('overdue'),
            onClick: onQuickFilters.bind(this, 'overdue'),
            class: 'overdue'
          }
        ],
        rightButtons: [
          {
            type: 'analytics',
            module: 'workflow'
          }
        ],
        search: {
          filters,
          onFilter,
          onSearch,
          value
        }
      }

      if (enableTimesheet) {
        toolbar.rightButtons.push({
          type: 'icon',
          icon: 'time-tracking',
          onClick: exportTimesheetReport
        })
      }

      if ($rootScope.isUserSysAdminAdmin()) {
        toolbar.rightButtons.push({
          type: 'icon',
          icon: 'clipboard',
          onClick: goToBriefingsPage
        }, {
          type: 'icon',
          icon: 'settings',
          onClick: openBoardSettings
        })
      }

      const buttons = [
        {
          type: 'badge',
          icon: 'inbox',
          count,
          onClick: goToInbox
        },
        {
          type: 'dropdown',
          btnType: 'icon',
          icon: '',
          options: []
        },
        {
          type: 'button',
          btnType: 'primary',
          icon: 'plus',
          label: $translate.instant('createNew'),
          onClick: () => openCreateTaskDialog(false)
        }
      ]

      toolbar.rightButtons.push(...buttons)

      return toolbar
    }

    return {
      rightButtons: [
        {
          type: 'badge',
          icon: 'inbox',
          count,
          onClick: goToInbox
        },
        {
          type: 'dropdown',
          btnType: 'icon',
          icon: '',
          options: []
        },
        {
          type: 'dropdown',
          btnType: 'icon',
          icon: 'plus',
          options: [
            {
              icon: 'file-text',
              label: $translate.instant('requestForUser'),
              onClick: openNewRequestDialog.bind(this, true)
            },
            {
              icon: 'file-plus',
              label: $translate.instant('task'),
              onClick: openNewTaskDialog
            },
            {
              icon: 'file-plus',
              label: $translate.instant('taskWithForm'),
              onClick: openNewRequestDialog
            }
          ]
        }
      ],
      search: {
        filters,
        onFilter,
        onSearch,
        value
      }
    }
  }

  function getHeaderNavigation (board) {
    boardInfo = board

    return {
      backButton: {
        onClick: goToBoardsPage
      },
      boardSelection: {
        board: boardInfo
      }
    }
  }

  function mergeQuickFilters (allFilters, quickFilters) {
    if (quickFilters.assignees) {
      const index = allFilters.assignees.findIndex(item => item === quickFilters.assignees)

      if (index === -1) {
        allFilters.assignees.push(quickFilters.assignees)
      }
    }

    if (quickFilters.authors) {
      const index = allFilters.authors.findIndex(item => item === quickFilters.authors)

      if (index === -1) {
        allFilters.authors.push(quickFilters.authors)
      }
    }
  }
}

export { workflowHeaderService }
